import { __rest } from "tslib";
import * as React from 'react';
import { Content, Title } from '@patternfly/react-core';
import { css } from '@patternfly/react-styles';
export const CatalogItemHeader = (_a) => {
    var { className = '', iconImg = null, iconClass = null, title, vendor = null } = _a, props = __rest(_a, ["className", "iconImg", "iconClass", "title", "vendor"]);
    return (React.createElement("header", Object.assign({ className: css('catalog-item-header-pf', className) }, props),
        iconImg && React.createElement("img", { className: "catalog-item-header-pf-icon", src: iconImg, alt: "" }),
        !iconImg && iconClass && React.createElement("span", { className: `catalog-item-header-pf-icon ${iconClass}` }),
        React.createElement("div", { className: "catalog-item-header-pf-text" },
            React.createElement(Title, { headingLevel: "h1", className: "catalog-item-header-pf-title" }, title),
            vendor && React.createElement(Content, { component: "p", className: "catalog-item-header-pf-subtitle" }, vendor))));
};
CatalogItemHeader.displayName = 'CatalogItemHeader';
//# sourceMappingURL=CatalogItemHeader.js.map